import { render } from "./SuccessPopup.vue?vue&type=template&id=1bbcc99a&scoped=true"
import script from "./SuccessPopup.vue?vue&type=script&lang=js"
export * from "./SuccessPopup.vue?vue&type=script&lang=js"

import "./SuccessPopup.vue?vue&type=style&index=0&id=1bbcc99a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbcc99a"]])

export default __exports__